const state = {
  editorUrl: ''
}

const mutations = {
  SET_EDITOR_URL (state, editorUrl) {
    state.editorUrl = editorUrl
    sessionStorage.setItem('editorUrl', editorUrl)
  }
}

const actions = {

}

export default {
  state,
  mutations,
  actions
}
